import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { EmployeeMcpPanel } from './EmployeeMcpPanel';
import { McpServersPanel } from './McpServersPanel';

/* Whoever turns tools on for the company also adds, connects, signs in and
   removes the company's servers here, below their own. */
export const McpSettingsPanel: React.FC = () => {
  const { can } = usePermissions();
  return (
    <div className="mx-auto max-w-[1000px]">
      <EmployeeMcpPanel />
      {can('aai_enable_tools_company') && (
        <div className="mt-8">
          <McpServersPanel />
        </div>
      )}
    </div>
  );
};

export default McpSettingsPanel;
